import { apiClient } from './_shared.js'

export async function getCloudStorageStatus() {
  return await apiClient('/cloud-storage/status')
}

export async function getYandexDiskAuthUrl() {
  return await apiClient('/cloud-storage/yandex/auth')
}

export async function disconnectYandexDisk() {
  return await apiClient('/cloud-storage/yandex/disconnect', { method: 'POST' })
}

export async function getAiCameraClips() {
  const data = await apiClient('/cloud-storage/clips')
  return data.clips || []
}

export async function saveCameraClipToYandex(clipData) {
  return await apiClient('/cloud-storage/clip-and-upload', {
    method: 'POST',
    body: clipData,
  })
}
